@let freightData = freight();
@let hideCols = hideColumns();
@if (freightData.id !== undefined && freightData.id !== '' && freightData.stopsBasic.length > 0) {
  <ion-card
    button="true"
    [routerLink]="[`/tabs/${AppTab.IN_PROGRESS}`, freightData.id]"
    routerDirection="root"
    routerLinkActive="active"
    class="freight"
    [class.freight--to-load]="freightData.nextStopType === EStopType.LOAD"
    [class.freight--to-unload]="freightData.nextStopType === EStopType.UNLOAD"
    [class.freight--to-unload_load]="freightData.nextStopType === EStopType.UNLOAD_LOAD"
    [class.freight--missing-vehicles]="isMissingVehicles()"
  >
    <ion-card-content>
      <ion-grid
        fixed="true"
        class="ion-no-padding"
      >
        <ion-row class="ion-align-items-stretch">
          <ion-col
            size="12"
            [sizeLg]="hideCols ? '12' : '8'"
            class="ion-no-padding"
          >
            @if (freightData) {
              <lib-freight-carrier-inprogress-card-basic
                [freight]="freightData"
                [hideColumns]="hideCols"
              ></lib-freight-carrier-inprogress-card-basic>
            }
          </ion-col>
          <ion-col
            size="12"
            [sizeLg]="hideCols ? '12' : '4'"
            class="ion-display-flex ion-flex-column ion-justify-content-between"
          >
            <div class="driver-vehicles">
              @if (canViewDrivers() && freightData.drivers && freightData.drivers.length > 0) {
                <p class="fs-xs">
                  <span class="extra-info-badge">
                    <ion-icon
                      slot="start"
                      aria-hidden="true"
                      src="../assets/material-symbols/id_card_24dp.svg"
                    ></ion-icon>
                    {{ printDrivers(freightData.drivers) }}
                  </span>
                </p>
              }
              @if (freightData.vehicles && freightData.vehicles.length > 0) {
                <p class="fs-xs">
                  <span class="extra-info-badge">
                    <ion-icon
                      slot="start"
                      aria-hidden="true"
                      src="../assets/material-symbols/local_shipping_24dp.svg"
                    ></ion-icon>
                    {{ printVehicles(freightData.vehicles) }}
                  </span>
                </p>
              } @else if (isMissingVehicles()) {
                <strong class="fs-xs">
                  <ion-text color="danger">{{ 'freight.no_vehicles' | translate }}</ion-text>
                </strong>
              }

              @if (canManageVehicles() && freightData.vehicles.length === 0) {
                <lib-freight-carrier-assignation-button
                  [freight]="freightData"
                ></lib-freight-carrier-assignation-button>
              }
            </div>

            <div
              class="card-buttons"
              [class.card-buttons--responsive]="!hideCols"
            >
              <div class="card-buttons--start">
                <lib-freight-documentation-links [freight]="freightData"></lib-freight-documentation-links>
              </div>

              @if (canInteractWithStops() && freightData) {
                <div class="card-buttons--end">
                  <lib-freight-carrier-stop-button [freight]="freightData"></lib-freight-carrier-stop-button>
                </div>
              }
            </div>
          </ion-col>
        </ion-row>
      </ion-grid>
    </ion-card-content>
  </ion-card>
}
